import type { TypeRootState } from '@/store/store';

export const selectSessionStatus = (state: TypeRootState) => state.auth.status;
export const selectSessionUser = (state: TypeRootState) => state.auth.user;
export const selectSessionRole = (state: TypeRootState) => state.auth.user?.role ?? null;
